import apiClient from 'hub-http/clients/apiClient';
import I18n from 'I18n';
import { PropertyDataSensitivity } from 'customer-data-objects/property/PropertyDataSensitivity';
export const getBuildTokenPaths = paths => data => {
  if (!data || !data.dataTokenPaths) {
    return {};
  }
  return paths.reduce((acc, path) => {
    const pathData = data.dataTokenPaths[path];
    acc[path] = {
      label: '',
      resolvable: false,
      type: ''
    };
    if (pathData && pathData.resolvable) {
      acc[path].resolvable = pathData.resolvable;
      let node = pathData.node;
      let parentNode;
      while (node && node.childNodes && node.childNodes.length) {
        if (node.name && node.nodeType !== 'FIELD') {
          acc[path].type = node.name;
        }
        if (node.path === path) {
          // This allows us to match parent path objects, like "Owner" object,
          // instead of indexing into the first nested child property
          break;
        }
        parentNode = node;
        node = node.childNodes[0];
      }
      if (node) {
        acc[path].label = node.parentLabels ? [...node.parentLabels, node.label].join(' > ') : node.label;
        let dataSensitivity = node.dataSensitivity;
        if (parentNode && !dataSensitivity) {
          dataSensitivity = parentNode.dataSensitivity;
        }
        if (dataSensitivity === PropertyDataSensitivity.STANDARD || dataSensitivity === PropertyDataSensitivity.HIGH) {
          acc[path].disabled = true;
          acc[path].disabledTooltip = I18n.text('data-token-views.dataSensitivityTooltip');
        }
      }
    }
    return acc;
  }, {});
};
export function fetchTokenPaths(paths, requestConfig) {
  const {
    dataTokenContext,
    supportedCrmObjectFQNs,
    hideSiteSettingsCategory,
    includeSubscriptionTypeCategory
  } = requestConfig;
  const requestParameters = {};
  if (dataTokenContext) {
    requestParameters.dataTokenContext = dataTokenContext;
  }
  if (supportedCrmObjectFQNs && supportedCrmObjectFQNs.length > 0) {
    requestParameters.dataTokenSources = {
      crmObjectTypeFQNs: supportedCrmObjectFQNs,
      deliverOfficeSettings: !hideSiteSettingsCategory,
      deliverSubscriptionType: includeSubscriptionTypeCategory
    };
  }
  return apiClient.post('data-tokens/v1/paths', {
    data: Object.assign({
      dataTokenPaths: paths
    }, requestParameters)
  }).then(getBuildTokenPaths(paths));
}